module.exports = __webpack_public_path__ + "static/img/twin-city-3.934ba215.png";